import { useMediaQuery, useTheme } from '@mui/material';
import findLast from 'lodash/findLast';

type Breakpoint = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

type ResponsiveValues<P> = {
  [key in Breakpoint]?: P;
};

export const useResponsive = () => {
  const theme = useTheme();

  const matches = {
    xs: useMediaQuery(theme.breakpoints.up('xs')),
    sm: useMediaQuery(theme.breakpoints.up('sm')),
    md: useMediaQuery(theme.breakpoints.up('md')),
    lg: useMediaQuery(theme.breakpoints.up('lg')),
    xl: useMediaQuery(theme.breakpoints.up('xl')),
  };

  return function <P>(responsiveValues: ResponsiveValues<P>) {
    const match = findLast(
      theme.breakpoints.keys,
      (breakpoint) => matches[breakpoint] && responsiveValues[breakpoint] != null
    );

    return match && responsiveValues[match];
  };
};
